import React, { useEffect, useState } from "react";

const LoadingScreen = ({ loading }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!loading) {
      // Start fade-out effect
      const timer = setTimeout(() => {
        setFadeOut(true);
      }, 300); // Delay before starting fade-out

      return () => clearTimeout(timer);
    } else {
      // Reset fadeOut when loading starts
      setFadeOut(false);
    }
  }, [loading]);

  // If loading is false and fadeOut is true, hide the component
  const shouldHide = !loading && fadeOut;

  return (
    <div
      style={{
        ...styles.loadingScreen,
        opacity: fadeOut ? 0 : 1, // Adjust opacity for fade-out effect
        transition: 'opacity 0.6s ease', // Adjusted transition for a smoother fade-out
        display: shouldHide ? 'none' : 'flex', // Hide with display none when fadeOut is true
      }}
    >
      <div style={styles.loadingSpinner}></div>
    </div>
  );
};

// Inline styles for the loading screen and spinner
const styles = {
  loadingScreen: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: '#fff', // Adjust color as needed
    zIndex: 9999, // Ensure it's above other content
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingSpinner: {
    border: '8px solid rgba(0, 0, 0, 0.1)', // Light gray background
    borderLeft: '8px solid #1565C0', // Dark Navy Spinner
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    animation: 'spin 1s linear infinite',
  },
};

// Keyframes for the spinner animation
const keyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}`;

// Append keyframes to the head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = keyframes;
document.head.appendChild(styleSheet);

export default LoadingScreen;
